import { Outlet, createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/it/strumenti')({
  component: Outlet,
})
